import { createContext, ReactNode, useContext, useMemo } from 'react'
import { useDrives } from '@/stores/useDrives.ts'
import { HeyDriveType } from '@/models/drive.ts'

interface ShopBrand {
  name: string
  isProf: boolean
}

const ShopBrandContext = createContext<ShopBrand>({ name: 'FridaySnap', isProf: false })

export function ShopBrandProvider({ children }: { children: ReactNode }) {
  const { currentDrive } = useDrives()
  const value = useMemo<ShopBrand>(() => {
    const isProf = currentDrive?.drive_type === HeyDriveType.PROF
    return {
      name: isProf ? 'PicField' : 'FridaySnap',
      isProf,
    }
  }, [currentDrive?.drive_type])

  return <ShopBrandContext.Provider value={value}>{children}</ShopBrandContext.Provider>
}

export function useShopBrand() {
  return useContext(ShopBrandContext)
}
